import React from 'react';
import {Row, Col, Card} from 'react-materialize';
import physicist from "../../images/physicist.png";
import solar_radiation from "../../images/solar_radiation.png";
import noise from "../../images/noise.png";
import temperature from "../../images/temperature.png";
import humidity from "../../images/humidity.png";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const RiscoFisico = () => (

    <Card>
        {/*RISCOS FÍSICOS*/}
        <Row>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={physicist} className={"img"}/> </div>

            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"physical.header"} defaultMessage={"Risco físico"}/></b></p></h5>
            </Col>
        </Row>

        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>
                <div align="center">
                    <img src={solar_radiation} className={"img"}/></div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">

                    <p> <b><FormattedMessage id={"solar.radiation"} defaultMessage={"Radiação Solar"}/></b></p>

                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"solar.radiation.text"} defaultMessage={"Exposição frequente do indivíduo com agentes radioativos. Na aquicultura a exposição a radiação ultravioleta do Sol é a mais frequente."} /></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"solar.radiation.text2"} defaultMessage={"Câncer de pele"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text3"} defaultMessage={"Desidratação"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text4"} defaultMessage={"Dor de cabeça"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text5"} defaultMessage={"Queimaduras na pele (primeiro e segundo grau)"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text6"} defaultMessage={"Catarata"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text7"} defaultMessage={"Insolação"}/></p>
                        <p><FormattedMessage id={"solar.radiation.text8"} defaultMessage={"Dermatites"}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"solar.radiation.text9"} defaultMessage={"Trabalho em áreas cobertas e protegidas do sol."} /></p>
                        <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"} /></b></li>
                        <p><FormattedMessage id={"solar.radiation.text10"} defaultMessage={"Usar protetor solar, chapéus e óculos solares."} /></p>
                            <p><FormattedMessage id={"solar.radiation.text11"} defaultMessage={"Reduzir a exposição a luz solar com rotatividade de trabalho."}/> </p>
                                <p><FormattedMessage id={"solar.radiation.text12"} defaultMessage={"Realizar exames de pele em pontos suspeitos"}/> </p> </ul> </ul>
                </div> <br/> </Col> </Row>

        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>
                <div align="center">
                    <img src={noise} className={"img"}/></div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p> <b><FormattedMessage id={"noise"} defaultMessage={"Ruído"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedHTMLMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"noise.text"} defaultMessage={"Exposição constante a sons emitidos pelo motor do barco"}/></p>
                        <p><FormattedMessage id={"noise.text2"} defaultMessage={"Máquinas de lavagem de ostras"}/></p>
                        <p><FormattedMessage id={"noise.text3"} defaultMessage={"Lavadoras de alta pressão"}/></p>
                        <li><b> <FormattedMessage id={"risksdamage"} defaultMessage={"Risco/Danos à Saúde"}/></b></li>
                        <p><FormattedMessage id={"noise.text4"} defaultMessage={"Estresse físico e psicológico"}/></p>
                        <p><FormattedMessage id={"noise.text5"} defaultMessage={"Redução na produtividade"}/></p>
                        <p><FormattedMessage id={"noise.text6"} defaultMessage={"Interferência na comunicação e concentração"}/></p>
                        <p><FormattedMessage id={"noise.text7"} defaultMessage={"Dores de cabeça"}/></p>
                        <p><FormattedMessage id={"noise.text8"} defaultMessage={"Perda de audição temporária ou permanente"} /></p>
                        <li><b> <FormattedMessage id={"control"} defaultMessage={"Controle e Prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"noise.text9"} defaultMessage={"Substituição por equipamento de menor ruído."} /></p>
                        <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"noise.text10"} defaultMessage={"Construir barreiras que evitem que o ruído chegue ao trabalhador."}/></p>
                        <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"noise.text11"} defaultMessage={"Usar protetor auricular"} /></p>
                        <p><FormattedMessage id={"noise.text12"} defaultMessage={"Rotatividade de trabalho"} /></p>
                        <p><FormattedMessage id={"noise.text13"} defaultMessage={"Intervalos entre as atividades"}/></p>
                            <p><FormattedMessage id={"noise.text14"} defaultMessage={"Usar equipamentos de proteção individual (EPI)"} /></p> </ul> </ul>
                </div> <br/> </Col>
        </Row>
        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>
                <div align="center">
                    <img src={temperature} className={"img"}/> </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p> <b> <FormattedMessage id={"extreme"} defaultMessage={"Temperaturas extremas"}/></b> </p>

                    <ul className={"browser-default"}>
                        <li><b> <FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo:"}/></b></li>
                        <p><FormattedMessage id={"extreme.text"} defaultMessage={"Exposição intensa aos raios solares em temperaturas muito altas por causa de trabalhos a céu aberto."}/></p>
                        <p><FormattedMessage id={"extreme.text2"} defaultMessage={"Exposição longa a temperaturas muito baixas, vento chuva e água."}/></p>
                        <li><b><FormattedMessage id={"risksdamage"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"extreme.text3"} defaultMessage={"Insolação;"} /></p>
                        <p><FormattedMessage id={"extreme.text4"} defaultMessage={"Queimaduras;"} /></p>
                        <p><FormattedMessage id={"extreme.text5"} defaultMessage={"Desidratação;"}/></p>
                        <p><FormattedMessage id={"extreme.text6"} defaultMessage={"Resfriados;"}/></p>
                        <p><FormattedMessage id={"extreme.text7"} defaultMessage={"Gripe;"}/></p>
                        <p><FormattedMessage id={"extreme.text8"} defaultMessage={"Pneumonia;"}/></p>
                        <p><FormattedMessage id={"extreme.text9"} defaultMessage={"Quadros de hipotermia;"}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e Prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"extreme.text10"} defaultMessage={"Trabalho em áreas cobertas;"}/> </p>
                        <p><FormattedMessage id={"extreme.text11"} defaultMessage={"Controles de engenharia: ventilação, exaustores e isolamento térmico."} /></p>
                        <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"extreme.text12"} defaultMessage={"Utilizar protetores solares, bonés ou chapéus;"} /></p>
                        <p><FormattedMessage id={"extreme.text13"} defaultMessage={"Utilizar roupas de proteção e calçados apropriados;"} /></p>
                        <p><FormattedMessage id={"extreme.text14"} defaultMessage={"Rotatividade de trabalho;"}/></p>
                        <p><FormattedMessage id={"extreme.text15"} defaultMessage={"Intervalos para a ingestão de líquidos evitando a desidratação em temperaturas elevadas;"}/></p>
                            <p><FormattedMessage id={"extreme.text16"} defaultMessage={"Intervalos para a ingestão de bebidas quentes evitando as consequências de temperaturas baixas;"}/></p> </ul> </ul>
                </div> <br/> </Col>
        </Row>



        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>
                <div align="center">
                    <img src={humidity} className={"img"} /> </div>
            </Col>

            <Col s={10} m={10}> <div align="justify">
                <p> <b> <FormattedMessage id={"humidity"} defaultMessage={"Umidade e exposição a água"} /></b></p>
                <ul className={"browser-default"}>
                    <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo:"}/></b></li>
                    <p><FormattedMessage id={"humidity.text"} defaultMessage={"Exposição durante a ocorrência de chuvas;"}/></p>
                    <p><FormattedMessage id={"humidity.text2"} defaultMessage={"Exposição a água do mar, tanques e viveiros;"}/></p>
                    <p><FormattedMessage id={"humidity.text3"} defaultMessage={"Exposição a água usada na limpeza e locais úmidos;"}/></p>
                    <li><b><FormattedMessage id={"risksdamage"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>

                    <p><FormattedMessage id={"humidity.text4"} defaultMessage={"Queda da pressão arterial;"}/></p>
                    <p><FormattedMessage id={"humidity.text5"} defaultMessage={"Ressecamento das vias aéreas superiores, mucosas e pele;"}/></p>
                    <p><FormattedMessage id={"humidity.text6"} defaultMessage={"Escorregões e quedas;"}/></p>
                    <p><FormattedMessage id={"humidity.text7"} defaultMessage={"Doenças respiratórias, urinárias e infecciosas."}/></p>
                    <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e Prevenção:"}/></b></li>
                    <ul className={"browser-default"}>
                    <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                    <p><FormattedMessage id={"humidity.text8"} defaultMessage={"Construir barreiras que evitem o contato direto com a umidade."}/></p>
                    <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                    <p><FormattedMessage id={"humidity.text9"} defaultMessage={"Intervalos entre as atividades;"}/></p>
                        <p><FormattedMessage id={"humidity.text10"} defaultMessage={"Usar equipamentos de proteção individual (EPI) como luvas, botas e macacões."}/></p> </ul> </ul>
            </div> <br/> </Col>
        </Row>

    </Card>
);

export default RiscoFisico;